import { useEffect, useState } from 'react';
import { getServiceConfig } from 'utility';

const useCurrencyUnit = (statusData) => {
  const [currencyUnit, setCurrencyUnit] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchConfig = async () => {
      try {
        const res = await getServiceConfig();
        const config = res?.result ?? res;
        const value = statusData ? config : config?.currencyLabel;

        if (isMounted) {
          setCurrencyUnit(value);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchConfig();

    return () => {
      isMounted = false;
    };
  }, [statusData]);

  return currencyUnit;
};

export { useCurrencyUnit };
